module.exports = __webpack_public_path__ + "static/img/shiba.8b1330c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shiba.png
// module id = 2X7Z
// module chunks = 1